import { authFetch } from "~/services/fetch";

// ! GRÁFICO DE PIZZA
export async function getOccurrencesAssociatedObjectByType({
  startDate,
  finishDate,
  objectTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-object-by-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        object_type_id: objectTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedObjectByCircunstance({
  startDate,
  finishDate,
  objectTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-object-by-circunstance',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        object_type_id: objectTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedObjectByDestination({
  startDate,
  finishDate,
  objectTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-object-by-destination',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        object_type_id: objectTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedObjectByOccurrenceType({
  startDate,
  finishDate,
  objectTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-object-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        object_type_id: objectTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedObjectByKindType({
  startDate,
  finishDate,
  objectTypeId,
  circumstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-object-by-kind',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        object_type_id: objectTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}


